import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import { Collections, type DoctorBranchRolesResponse } from "@/types/pocketbase.ts";
import type { FullListOptions, ListOptions, OneOptions } from "@/types/query-options";

const COLLECTION = Collections.DoctorBranchRoles;

export const doctorBranchRolesQueries = {
	all: () => [COLLECTION],
	lists: () => [...doctorBranchRolesQueries.all(), "list"],
	list: <Texpand = unknown>(params: ListOptions = { page: 1, perPage: 10, options: {} }) =>
		queryOptions({
			queryKey: [
				...doctorBranchRolesQueries.lists(),
				{ page: params.page, perPage: params.perPage, options: params.options },
			],
			queryFn: () =>
				pb
					.collection(COLLECTION)
					.getList<DoctorBranchRolesResponse<Texpand>>(params.page, params.perPage, params.options),
			placeholderData: keepPreviousData,
		}),
	fullLists: () => [...doctorBranchRolesQueries.lists(), "fullList"],
	fullList: <Texpand = unknown>(options?: FullListOptions) =>
		queryOptions({
			queryKey: [...doctorBranchRolesQueries.fullLists(), options ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getFullList<DoctorBranchRolesResponse<Texpand>>({
					...options?.options,
					sort: options?.options?.sort ?? "-created",
				}),
			placeholderData: keepPreviousData,
		}),
	ones: () => [...doctorBranchRolesQueries.all(), "one"],
	one: <Texpand = unknown>(params?: OneOptions) =>
		queryOptions({
			queryKey: [...doctorBranchRolesQueries.ones(), params?.id, params?.options ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getOne<DoctorBranchRolesResponse<Texpand>>(params?.id ?? "", params?.options),
			enabled: Boolean(params?.id),
		}),
	first: <Texpand = unknown>(params?: ListOptions) =>
		queryOptions({
			queryKey: [...doctorBranchRolesQueries.ones(), params ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getFirstListItem<DoctorBranchRolesResponse<Texpand>>("", params?.options),
		}),
};
